export var AlertType;
(function (AlertType) {
    AlertType["high"] = "High";
    AlertType["low"] = "Low";
    AlertType["info"] = "Informative";
})(AlertType || (AlertType = {}));
export var StatusType;
(function (StatusType) {
    StatusType["complete"] = "Complete";
    StatusType["inProgress"] = "In Progress";
    StatusType["failed"] = "Failed";
    StatusType["cancelled"] = "Cancelled";
})(StatusType || (StatusType = {}));
export var RiskType;
(function (RiskType) {
    RiskType[RiskType["negligible"] = 0] = "negligible";
    RiskType[RiskType["low"] = 1] = "low";
    RiskType[RiskType["medium"] = 2] = "medium";
    RiskType[RiskType["high"] = 3] = "high";
    RiskType[RiskType["extreme"] = 4] = "extreme";
})(RiskType || (RiskType = {}));
